import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MaterialPopup from '../components/MaterialPopup';
import DisposablePopup from '../components/DisposablePopup';
import ImplantPopup from '../components/ImplantPopup';
import InstrumentPopup from '../components/InstrumentPopup';
import EquipmentPopup from '../components/EquipmentPopup';
import { decodeRouteParam } from '../util/routeParams';

export const MaterialDetailPage = () => {
  const { materialName } = useParams();
  const navigate = useNavigate();
  return (
    <MaterialPopup
      variant="page"
      materialName={decodeRouteParam(materialName)}
      onClose={() => navigate('/stock')}
    />
  );
};

export const DisposableDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <DisposablePopup
      variant="page"
      disposableId={id}
      onClose={() => navigate('/disposables')}
    />
  );
};

export const ImplantDetailPage = () => {
  const { implantName } = useParams();
  const navigate = useNavigate();
  return (
    <ImplantPopup
      variant="page"
      implantName={decodeRouteParam(implantName)}
      onClose={() => navigate('/implants')}
    />
  );
};

export const InstrumentDetailPage = () => {
  const { instrumentName } = useParams();
  const navigate = useNavigate();
  return (
    <InstrumentPopup
      variant="page"
      instrumentName={decodeRouteParam(instrumentName)}
      onClose={() => navigate('/instruments')}
    />
  );
};

export const EquipmentDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <EquipmentPopup
      variant="page"
      equipmentId={id}
      onClose={() => navigate('/equipment')}
    />
  );
};
